const jsonSchema = [
  {
    name: 'date',
    label: 'Date',
    type: 'date',
    required: true,
    showInList: true
  },

  {
    name: 'type',
    label: 'Type',
    type: 'multiselect',
    required: true,
    showInList: true
  },
  {
    name: 'value',
    label: 'Value',
    type: 'number',
    required: false,
    showInList: false
  }

  // Add more fields as needed
];
export default jsonSchema;
